import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DataVolumetryTableComponent = /** @class */ (function () {
    function DataVolumetryTableComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.dataSource = [];
        this.isLoading = true;
        this.displayedColumns = [
            'name',
            'totalMaintenancesDone',
            'totalMaintenancesCanceled',
            'totalMaintenancesBacklog',
            'totalMaintenances',
            'maintenancesByDay'
        ];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    return DataVolumetryTableComponent;
}());
export { DataVolumetryTableComponent };
